module.exports = __webpack_public_path__ + "img/DEPOIS.79302621.jpg";